import { RoutePermittedRole } from './AppEnums';
import { getSessionStorage, SESSION_STORAGE_NAMES } from '@libs/storage/src/lib/session';

export const authRole = {
  Admin: [RoutePermittedRole.Admin],
  User: [RoutePermittedRole.User, RoutePermittedRole.Admin],
};

export const defaultUser: any = {
  uid: 'john-alex',
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: RoutePermittedRole.User,
  photoURL: 'https://www.webling.kr/views/res/imgs/common/favicon.svg',
  // photoURL: '/assets/images/avatar/A11.jpg',
};
export const allowMultiLanguage = process.env.NX_MULTILINGUAL === 'true';
export const fileStackKey = process.env.NX_FILESTACK_KEY as string;
export const initialUrl =
  getSessionStorage(SESSION_STORAGE_NAMES.INITIAL_URL) || (process.env.NX_INITIAL_URL as string); // this url will open after login
export const currencyCodes = ['KRW', 'USD', 'JPY'];

export const ROUTES = {
  AUTH: {
    SIGNIN: '/signin',
    SIGNUP: '/signup',
    SIGNIN_EMAIL: '/signin/email',
    SIGNUP_EMAIL: '/signup/email',
    SIGNUP_VERIFY_PHONE: '/signup/verify-phone',
    SIGNUP_GOOGLE_INFO: '/signup/google-info',
    SIGNUP_COMPLETE: '/signup/complete',
    FIND_PASSWORD: '/forget-password',
    CHANGE_PASSWORD: '/change-password',
  },

  D2C_CHANNEL_REQUEST: '/d2c-channel-request',

  STORE_REGISTRATION: {
    BASE: '/StoreRegister',
    DETAIL: (id: string | number) => `/StoreRegister/${id}`,
  },

  STORE_CONNECT: {
    BASE: '/StoreConnect',
  },

  DISCOUNT_MANAGEMENT: {
    BASE: '/discountmanagement',
    REGISTER: '/discountmanagement/register',
    DETAIL: (id: string | number) => `/discountmanagement/${id}`,
  },

  SUB_CHANNEL_MANAGEMENT: {
    LIST: '/subchannelList',
    DETAIL: (id: string | number) => `/subchannelList/detail/${id}`,
    ORDER_LIST: '/subchannelOrderList',
    ORDER_DETAIL: (id: string | number) => `/subchannelOrderList/detail/${id}`,
    PAYMENT_RECORD: '/subchannelPaymentRecord',
    SUB_CHANNEL_PAYMENT_RECORD: `/subchannelPaymentRecord`,
  },
};
